var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformationIcon = function SvgInformationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#880A47",
    d: "M14.5 3.3C8.315 3.3 3.3 8.315 3.3 14.5s5.015 11.2 11.2 11.2 11.2-5.015 11.2-11.2S20.685 3.3 14.5 3.3m.933 16.8h-1.867v-6.533h1.867zm-.933-8.867a1.4 1.4 0 1 1 0-2.8 1.4 1.4 0 0 1 0 2.8"
  })));
};
export default SvgInformationIcon;